import React from 'react';
import styled from 'styled-components';
import Hamburger from 'js/components/core/Icons/Hamburger';
import { lightGrey3Color, lightGrey1Color, lightGrey2Color } from 'js/config/style';

export const background = lightGrey1Color;

const Container = styled.div`
  user-select: none;
  height: 100%;
`;

const Button = styled(Hamburger)`
  height: 100%;
  width: 3rem;
  padding: 0 1rem;
  display: block;
  cursor: pointer;
  background: ${({ open }) => (open ? background : 'transparent')};
  border-top-left-radius: 0.25rem;
  position: relative;
  z-index: 2;
  border-right: 1px solid ${lightGrey2Color};

  .lines {
    fill: ${({ open }) => (open ? 'black' : lightGrey3Color)};
  }

  &:hover .lines {
    fill: ${({ open }) => (open ? 'black' : lightGrey3Color.darken())};
  }

  &:active .lines {
    fill: black;
  }
`;

export default ({ onClick, open }) => (
  <Container onClick={onClick}>
    <Button open={open} />
  </Container>
);
